import fetch from "../fetch";

export default ({ propertyId } = {}) =>
  fetch({ path: `/re/prop-masters/${propertyId}` });
